module.exports = __webpack_public_path__ + "static/media/uzit_logo.3d18f629.png";